import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Github from "./Github";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/about.png";
import Toolstack from "./Toolstack";
import ToolsPhysics from "./ToolsPhysics";
import TechstackPhysics from "./TechstackPhysics";
import {FaArrowLeftLong, FaArrowRightLong} from "react-icons/fa6";

function About() {
  return (
    <Container fluid className="about-section">
      <Container style={{ paddingTop: "4rem", display: "flex", flexDirection: "column", gap: "8rem"}}>
        <div>
          <h1 style={{ fontSize: "2.1em"}}>
            Who <strong className="textColor">AM I?</strong>
          </h1>
          <Aboutcard />
        </div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between"}}>
          <div style={{paddingLeft: "5rem"}}>
            <h1 className="project-heading">
              My <strong className="textColor">Skillset </strong>
            </h1>
            <FaArrowRightLong size={80}/>
          </div>
          <TechstackPhysics />
        </div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between"}}>
        <ToolsPhysics />
          <div style={{paddingRight: "5rem"}}>
            <h1 className="project-heading">
              <strong className="textColor">Tools</strong> I use
            </h1>
            <FaArrowLeftLong size={80}/>
          </div>
        </div>
        <div>
          <Github />
        </div>
      </Container>
    </Container>
  );
}

export default About;
